import React from 'react';
import { makeStyles, TextField, Paper, Typography } from '@material-ui/core';
import { formatDate } from '@/services/utils/date-time';
import { CustomerModel } from '@/models/customer';

const useStyles = makeStyles(() => ({
	paper: {
		padding: '20px',
		marginBottom: '30px',
	},
}));

interface Props {
	customer: CustomerModel
	formEnabled: boolean
}

export const Personal = (props: Props) => {
	const classes = useStyles();
	const birthDate = props.customer.birthDate ? formatDate(props.customer.birthDate, 'dd.MM.yyyy') : 'Unknown';

	return (
		<Paper component="ul" className={classes.paper}>
			<Typography variant="h4" component="h4">Personal</Typography>
			<form noValidate autoComplete="off">
				<TextField
					name="firstName"
					type="text"
					value={props.customer.firstName}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="First name"
					variant="outlined"
				/>
				<TextField
					name="lastName"
					type="text"
					value={props.customer.lastName}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="Last name"
					variant="outlined"
				/>
				<TextField
					name="birtDate"
					type="text"
					value={birthDate}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="Date of birth"
					variant="outlined"
				/>
				<TextField
					name="nationalityCode"
					type="text"
					value={props.customer.nationalityCode}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="Nationality"
					variant="outlined"
				/>
			</form>
		</Paper>
	);
};
